import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { EventCard } from "@/components/EventCard";
import { PageHeader, Spinner, EmptyState } from "@/components/common";

export default function PastEvents() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/events", { params: { status: "past" } }).then((r) => setEvents(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="past-events-page">
      <PageHeader caption="The Archive" title="Past Events" subtitle="Relive the moments. Browse photos and lineups from our previous shows." />
      <div className="mx-auto max-w-7xl px-4 pb-10 sm:px-8">
        {loading ? <Spinner /> : events.length ? (
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {events.map((e) => <EventCard key={e.id} event={e} />)}
          </div>
        ) : <EmptyState text="No past events archived yet." />}
      </div>
    </div>
  );
}
